// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
export const SYS_OPACITY_20_PCT = '20%';
export const SYS_OPACITY_90_PCT = '90%';
export const SYS_OPACITY_0_PCT = '0%';
export const SYS_OPACITY_100_PCT = '100%';
export const SYS_OPACITY_70_PCT = '70%';
export const CMP_OPACITY_UI_AVATAR_IMAGE_DEFAULT = '100%';
export const CMP_OPACITY_UI_AVATAR_IMAGE_DISABLED = '40%';
//# sourceMappingURL=opacity.generated.js.map